var magicStyles = [".time[data-v-7f489608]{margin:0;pointer-events:none}.text[data-v-7f489608]{font-size:var(--magic-time-font-size,13px);color:inherit}"];

export default magicStyles;
